import RokovaniePovPage from './RokovaniePovPage';

export default RokovaniePovPage;
